import { z } from 'zod';
import { dailyStatusSchema } from '../../shared/api';
import { API_PATHS } from '../../shared/routes';
import { fetchJson } from './http';

export type DailyStatus = z.infer<typeof dailyStatusSchema>;

export function readDailyStatus(credential: string): Promise<DailyStatus> {
  return fetchJson(dailyStatusSchema, API_PATHS.daily, { credential });
}
